import React, { Fragment } from 'react';
export const SocialProofTicker = () => {
  const text = '+750 artesãs ✦ Feito no Brasil 🇧🇷 ✦ Funciona no celular ✦ Adeus, achômetro ✦ Cálculo em tempo real ✦ Sem planilha. Sem caderno. Sem chute. ✦ ';
  return <div className="bg-ink py-4 overflow-hidden flex whitespace-nowrap" data-id="element-354">
      <div className="animate-[scrollTicker_60s_linear_infinite] flex" data-id="element-355">
        <span className="text-white font-medium text-sm tracking-wide px-4" data-id="element-356">
          {text.split('✦').map((part, i, arr) => <Fragment key={i} data-id="element-357">
              {part}
              {i < arr.length - 1 && <span className="text-gold mx-4" data-id="element-358">✦</span>}
            </Fragment>)}
        </span>
        <span className="text-white font-medium text-sm tracking-wide px-4" data-id="element-359">
          {text.split('✦').map((part, i, arr) => <Fragment key={`repeat-${i}`} data-id="element-360">
              {part}
              {i < arr.length - 1 && <span className="text-gold mx-4" data-id="element-361">✦</span>}
            </Fragment>)}
        </span>
      </div>
    </div>;
};